import BillingService from '@/services/BillingService';
import Loading from '@/components/widget/Loading';
export default {
  name: 'CreditCardDelete',
  components: {
    Loading
  },
  props: {
    record: Object
  },
  data() {
    return {
      openModal: false,
      loading: false
    };
  },
  methods: {
    deleteCreditCard(e) {
      if (e) {
        e.preventDefault();
      }
      if (this.loading) {
        return false;
      }
      this.loading = true;
      BillingService.delete(this.record.id).then(response => {
        this.$aim.notify(response);
      }).catch(error => {
        this.$aim.error(error.response);
      }).finally(() => {
        this.loading = false;
        this.$emit('refresh');
        this.close();
      });
    },
    close() {
      this.$nextTick(() => {
        this.$bvModal.hide('credit-card-delete-modal');
      });
    }
  }
};